<template>
  <el-col style="text-align: center; overflow-y: scroll;padding-bottom: 100px;" class="content">

    <el-col style="width: 96%;margin-left: 2%;  font-family:'Microsoft YaHei'; text-align: left;">

      <el-col class="cell_room" style="background-color:#AB745C;">
        <p class="cell_title">Leading Institutions</p>
        <el-row style="display: flex;flex-direction: row;">
          <ul>
            <li class="ui_li li_a" @click="cell_click('world_political_map')">World political map</li>
            <li class="ui_li li_a" @click="cell_click('global_satellite_image')">Global satellite image</li>
            <li class="ui_li li_a" @click="cell_click('global_elevation')">Global land elevation</li>
            <li class="ui_li">Global terrain slope</li>
          </ul>
          <ul style="margin-left: 50px;">
            <li class="ui_li">Global land cover</li>
            <li class="ui_li li_a"  @click="cell_click('global_soil')">Global soil</li>
            <li class="ui_li li_a"  @click="cell_click('global_climate_zones')">Global climate zones</li>
            <li class="ui_li">Global river system</li>
          </ul>
        </el-row>
      </el-col>




      <el-col class="cell_room" style="background-color:  #B7AF85;">
        <p class="cell_title">Global climate change</p>
        <el-row style="display: flex;flex-direction: row;">
          <ul>
            <li class="ui_li li_a"  @click="climateChange('cc_tmean_mean')">Global mean temperature</li>
            <li class="ui_li li_a"  @click="climateChange('cc_tstd_var')">Global temperature variability</li>
            <li class="ui_li li_a"  @click="climateChange('cc_txx_ext')">Global extremely high temperature</li>
            <li class="ui_li li_a"  @click="climateChange('cc_prcptot_mean')">Global mean precipitation</li>
            <li class="ui_li li_a"  @click="climateChange('cc_prcptot_var')">Global precipitation variability</li>
          </ul>
          <ul style="margin-left: 50px;">
            <li class="ui_li li_a"  @click="climateChange('cc_prcptot_ext')">Global extremely precipitation</li>
            <li class="ui_li li_a"  @click="climateChange('cc_sfcwind_mean')">Global mean wind speed</li>
            <li class="ui_li li_a"  @click="climateChange('cc_sfcwind_var')">Global variability of wind speed</li>
            <li class="ui_li li_a"  @click="climateChange('cc_sfcwindmax_ext')">Global extremely wind speed</li>
          </ul>
        </el-row>
      </el-col>




      <el-col class="cell_room" style="background-color:  #A0A8AB;">
        <p class="cell_title">Population and economic systems</p>
        <el-row style="display: flex;flex-direction: row;">
          <ul>
            <li class="ui_li">Global population</li>
            <li class="ui_li">Global domestic production</li>
            <li class="ui_li">Global crop distribution</li>
            <li class="ui_li">Global industrial value added</li>
            <li class="ui_li">Global road system</li>
          </ul>
          <ul style="margin-left: 50px;">
            <li class="ui_li">Global population exposure to high temperature</li>
            <li class="ui_li">Global GDP exposure to drought</li>
            <li class="ui_li">Global GDP exposure to flood</li>
            <li class="ui_li">Global crop exposure to extremely high temperature</li>
          </ul>
        </el-row>
      </el-col>


      <el-col class="cell_room" style="background-color: #ABA8B3;">
        <p class="cell_title">Global change risk</p>
        <el-row style="display: flex;flex-direction: row;">
          <ul>
            <li class="ui_li">Global population death risk to heatwave</li>
            <li class="ui_li">Global population death risk to flood</li>
            <li class="ui_li">Global crop yield risk—rice</li>
          </ul>
          <ul style="margin-left: 50px;">
            <li class="ui_li">Global crop yield risk—wheat</li>
            <li class="ui_li">Global crop yield risk—maize</li>
            <li class="ui_li">Global GDP loss risk to flood</li>
          </ul>
        </el-row>
      </el-col>



    </el-col>
  </el-col>
</template>

<script>
export default {
  name: "TableOfContents",
  methods:{
    cell_click(layer_code){
      let target_router = "/BNUMap/env?sm="+layer_code;
      this.$router.push({path:target_router});
    },
    climateChange(layer_code){
      let target_router = "/BNUMap/cc?sm="+layer_code;
      this.$router.push({path:target_router});
    }
  }
}
</script>

<style scoped>

.ui_li{
  font-size: 15px;
  color: #FFFFFF;
  letter-spacing: 0;
  text-align: justify;
  line-height: 35px;
  height: 35px;
  font-weight: bold;
}



.li_a{
  cursor: pointer;
}

.li_a:hover{
  font-style: italic;
}



.cell_room{
  background-color: white;
  padding: 0px 20px;
  padding-bottom: 30px;
  box-shadow: 5px 5px 5px rgba(0,0,0,0.2);
  color: white;
  margin-top: 5vh;
}

.cell_title{
  font-size: 30px;
  color: white;
  letter-spacing: 0;
  font-weight: bold;
}

.cell_item{
  font-size: 15px;
  color: #8A8A8A;
  letter-spacing: 0;
  text-align: justify;
  line-height: 24px;
}

.content{
  text-align: left;
}

.content::-webkit-scrollbar {
  display: none;/*隐藏滚动条*/
}
</style>



// WEBPACK FOOTER //
// src/view/BSD/About/TableOfContents.vue